import React, { Component } from "react";

import {Button, FormGroup, ControlLabel, FormControl} from "react-bootstrap";

class GroupEdit extends Component {

  render() {
    const group = this.props.group === null ? null : (
        <div>
          <FormGroup>
            <ControlLabel>Name</ControlLabel>
            <FormControl
              id="name"
              type="text"
              placeholder="Enter a name"
              value={this.props.group.name}
              onChange={event => this.props.onEdit(event)}
            />
          </FormGroup>
          <Button onClick={() => this.props.onSubmit()}>Submit</Button>
        </div>
      );

    return (
      <div className="groups-div-right">
        <Button
          className="groups-create-button"
          bsStyle="success"
          onClick={() => this.props.onCreate()}
        >
          Create a group
        </Button>
        {group}
      </div>
    )
  }
}

export default GroupEdit;



// WEBPACK FOOTER //
// ./src/components/groups/GroupEdit.js